import client from './bonds-client';

export const bondsApi = (params) => client().get('/bonds');
